<template>
  <div v-if="url" class="trbo-a-video">
    <video class="trbo-a-video__player" controls autoplay muted>
      <source :src="url">
      Your browser does not support video.
    </video>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object, // WizardPage
      required: true
    },
    questionData: {
      type: Object, // WizardPageData<VideoData>
      required: true
    }
  },
  computed: {
    url () {
      return this.questionData.videoUrl
    }
  }
}
</script>

<style scoped src="./video.scss" />
